<template>
    <div>
        <div v-if="!creating && !editing" class="row">
            <div class="col-6">
                <h4>Liste des associé·e·s</h4>
                <b-alert :show="noAssociate" variant="primary">
                    Aucun associé n'a été saisi pour cette société
                </b-alert>

                <div>
                    <associate
                        v-for="associate in associates"
                        :key="'associate' + associate.id"
                        :item="associate"
                    />
                </div>

                <b-button
                    v-if="!searching && !editing && !creating"
                    variant="primary"
                    size="sm"
                    @click="showSearch('physical')"
                >
                    <i class="fas fa-plus fa-fw"></i> Ajouter une personne
                    physique
                </b-button>
                <b-button
                    v-if="!searching && !editing && !creating"
                    variant="primary"
                    size="sm"
                    @click="showSearch('moral')"
                >
                    <i class="fas fa-plus fa-fw"></i> Ajouter une personne
                    morale
                </b-button>

                <moral-person-search
                    v-if="searching && personType === 'moral'"
                />
                <physical-person-search
                    v-if="searching && personType === 'physical'"
                />
            </div>
            <div class="col-6">
                <asset-handler/>
                <asset-repartition/>
            </div>
        </div>
        <div v-else>
            <div v-if="personType === 'physical'">
                <physical-person-create
                    v-if="creating"
                    :person-type="'associates'"
                />
                <physical-person-edit v-if="editing"/>
            </div>
            <div v-if="personType === 'moral'">
                <moral-person-create v-if="creating"/>
                <moral-person-edit v-if="editing"/>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Associate from './Associate'
import MoralPersonSearch from '../moralPersons/MoralPersonSearch'
import PhysicalPersonSearch from '../physicalPersons/PhysicalPersonSearch'
import PhysicalPersonCreate from '../physicalPersons/PhysicalPersonCreate'
import PhysicalPersonEdit from '../physicalPersons/PhysicalPersonEdit'
import MoralPersonCreate from '../moralPersons/MoralPersonCreate'
import MoralPersonEdit from '../moralPersons/MoralPersonEdit'
import AssetHandler from './AssetHandler'
import AssetRepartition from './AssetRepartition'

export default {
    name: 'Associates',

    components: {
        MoralPersonSearch,
        MoralPersonCreate,
        MoralPersonEdit,
        PhysicalPersonSearch,
        PhysicalPersonCreate,
        PhysicalPersonEdit,
        Associate,
        AssetHandler,
        AssetRepartition,
    },

    props: ['clientData'],

    data() {
        return {
            pappers: {},
            key: Date.now(),
        }
    },

    created() {
        this.$store.commit('legalVM/SET_CLIENT', this.clientData)
        this.$store.commit('legalVM/RESET_STATUS')
    },

    methods: {
        showSearch(type) {
            this.$store.commit('legalVM/SET_PERSON_TYPE', type)
            this.$store.commit('legalVM/SET_LINK_TYPE', 'associates')
            this.$store.commit('legalVM/SHOW_SEARCH')
        },

        showEdit() {
            this.$store.commit('legalVM/SET_LINK_TYPE', 'associates')
            this.$store.commit('legalVM/SHOW_EDIT')
        },
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            editing: (state) => state.legalVM.editing,
            searching: (state) => state.legalVM.searching,
            creating: (state) => state.legalVM.creating,
            personType: (state) => state.legalVM.personType,
        }),

        associates() {
            return this.client.associates === null || this.client.associates === undefined
                ? null
                : this.client.associates.data
        },

        noAssociate() {
            return this.associates === null || (this.associates.length === 0 && !this.searching && !this.editing)
        },
    },
}
</script>

<style scoped></style>
